import React from "react";
import Icons from "./icons";

export type IconNameType = "back" | "arrowRight" | "arrowBottom" | "arrowUp";

export interface Props {
  style?: React.CSSProperties;
  name: IconNameType;
  size?: number;
  color?: string;
  onClick?: () => void;
  width?: number;
}

export default function Icon({
  style,
  onClick,
  name,
  size = 20,
  color,
  width,
}: Props) {
  return (
    <i
      style={{ cursor: onClick ? "pointer" : "inherit", ...style }}
      onClick={onClick}
    >
      <Icons name={name} size={size} color={color} width={width} />
    </i>
  );
}
